/**
 * @name 账单管理
 */
import request from '@/utils/request'

export const getBillsSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/bills/setup'
  })
}

export const getBillsList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/bills',
    params
  })
}

export const getBillsDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/bills/${id}`
  })
}

export const deleteBillsDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/bills/${id}`
  })
}
